"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _reactRedux = require("react-redux");
var _DeviceChartContainerModule = _interopRequireDefault(require("../../styles/components/DeviceLineChart/DeviceChartContainer.module.css"));
var Charts = _interopRequireWildcard(require("../Charts"));
var _selectors = require("../../redux/selectors");
var _InfoPanel = require("../Legend/InfoPanel");
var _useGetChartLines = _interopRequireDefault(require("../../hooks/useGetChartLines"));
var _Calendar = require("../Calendar");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ChartContainer = _ref => {
  let {
    chartId,
    equipmentKey,
    isAlarm = false
  } = _ref;
  const minTemperature = 55;
  const {
    inProgress,
    isPrediction = false,
    dateType = '',
    rangeType
  } = (0, _reactRedux.useSelector)((0, _selectors.selectChartParams)(chartId));
  const alarmItem = (0, _reactRedux.useSelector)((0, _selectors.selectAlarmItemByChartId)(chartId));
  const [hoverLine, setHoverLine] = (0, _react.useState)();
  const [unCheckedLegend, setUnCheckedLegend] = (0, _react.useState)([]);
  const {
    lines,
    data
  } = (0, _useGetChartLines.default)({
    chartId,
    equipmentKey,
    hoverLine,
    unCheckedLegend,
    dateType,
    rangeType
  });
  (0, _react.useEffect)(() => {
    if (alarmItem) setHoverLine(alarmItem);
  }, [alarmItem]);
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: _DeviceChartContainerModule.default.chart_box
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_DeviceChartContainerModule.default.chart, " line-chart h-500")
  }, /*#__PURE__*/_react.default.createElement(Charts.CirculationChart, {
    data: inProgress ? [] : lines,
    rangeType: rangeType,
    dateType: dateType,
    minTemperature: minTemperature,
    hoverLine: hoverLine,
    isPrediction: isPrediction
  }), inProgress ? /*#__PURE__*/_react.default.createElement("div", {
    className: _DeviceChartContainerModule.default.circular_progress
  }, /*#__PURE__*/_react.default.createElement(_material.CircularProgress, {
    sx: {
      color: "var(--main-color-cl-01)"
    }
  })) : null), !isAlarm ? /*#__PURE__*/_react.default.createElement(_Calendar.CalendarChartWrap, {
    chartId: chartId
  }) : null), /*#__PURE__*/_react.default.createElement("hr", {
    className: "mb-35"
  }), /*#__PURE__*/_react.default.createElement(_InfoPanel.InfoPanel, {
    unChecked: unCheckedLegend,
    setUnChecked: setUnCheckedLegend,
    setHoverLine: setHoverLine,
    equipmentKey: equipmentKey,
    data: inProgress ? [] : data
  }));
};
var _default = exports.default = ChartContainer;